import { render, staticRenderFns } from "./UnkonwTable.vue?vue&type=template&id=32f59b61&scoped=true&"
import script from "./UnkonwTable.vue?vue&type=script&lang=js&"
export * from "./UnkonwTable.vue?vue&type=script&lang=js&"
import style0 from "./UnkonwTable.vue?vue&type=style&index=0&id=32f59b61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f59b61",
  null
  
)

export default component.exports